var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 23,
    viewBox: "0 0 33 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75347 22.938C6.76146 22.8113 4.8687 22.1663 3.34546 21.0952C1.82223 20.024 0.746398 18.5815 0.271589 16.9735C-0.203219 15.3656 -0.0527272 13.6744 0.701577 12.1416C1.45588 10.6087 2.77543 9.3125 4.4718 8.43804C4.83275 6.10606 6.20692 3.96298 8.33714 2.40986C10.4674 0.856729 13.2076 0 16.0451 0C18.8826 0 21.6229 0.856729 23.7531 2.40986C25.8833 3.96298 27.2575 6.10606 27.6185 8.43804C29.3148 9.3125 30.6344 10.6087 31.3887 12.1416C32.143 13.6744 32.2935 15.3656 31.8187 16.9735C31.3439 18.5815 30.268 20.024 28.7448 21.0952C27.2216 22.1663 25.3288 22.8113 23.3368 22.938V22.961H8.75347V22.938ZM17.5035 13.2943H21.8785L16.0451 7.25267L10.2118 13.2943H14.5868V18.1277H17.5035V13.2943Z",
    fill: "#6C13F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.6f057a39.svg";
export { ForwardRef as ReactComponent };